import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import './style.scss';
import { Button } from 'react-bootstrap';
import useViewport from 'services/viewport-hook';
const UniversalModal = ({
  isOpen,
  onClose,
  extraClass = '',
  title,
  children,
  footerButtons,
  size = 'md',
  customScroll = false,
  onEnter,
  dialogClassName = 'modal-90w',
  backdrop = undefined
}) => {
  const screen = useViewport();
  if (!isOpen) return null;
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size={size}
      keyboard={false}
      id="inviteModal"
      scrollable
      dialogClassName={screen.xs ? '' : dialogClassName}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop={backdrop}
      className={extraClass}
      onEnter={onEnter}
    >
      <Modal.Header closeButton className="univarsal-modal-header">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`univarsal-modal-body ${customScroll ? 'p-0' : ''}`}
      >
        {children}
      </Modal.Body>
      <Modal.Footer className="univarsal-modal-footer">
        {footerButtons.map((button, index) =>
          button?.custom ? (
            <>{button.custom}</>
          ) : (
            <Button
              key={index}
              className="w-100 mt-lg-20 "
              // disabled={loading || !ForgotPasswordFormIk.dirty}
              // onClick={() => setFieldErrorOnSubmit(false)}
              size="sm"
              {...button}
            >
              {button?.loading && (
                <i className="uil uil-spinner spinner mr-1"></i>
              )}
              {button.label}
            </Button>
          )
        )}
      </Modal.Footer>
    </Modal>
  );
};
UniversalModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footerButtons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      className: PropTypes.string,
      disabled: PropTypes.bool
    })
  ).isRequired,
  customScroll: PropTypes.bool
};

export default UniversalModal;
